// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"168":"2b118bfc","427":"d722c6b6","929":"866c93a9"}[chunkId] + ".js";
};